import { genericResources } from './generic';
import { errorResources } from './errors';
import { demoResources } from './demo';
import { homeResources } from './home';
import { propertyResources } from './property';

const resources = {
  en: {
    translation: {
      ...genericResources.en,
      ...errorResources.en,
      ...demoResources.en,
      ...homeResources.en,
      ...propertyResources.en,
    },
  },
  el: {
    translation: {
      ...genericResources.el,
      ...errorResources.el,
      ...demoResources.el,
      ...homeResources.el,
      ...propertyResources.el,
    },
  },
};

export default resources;
